export default __webpack_public_path__ + "images/AM.6ecfc89.png";